import { defineStore } from "pinia"
import { assignEntries } from '@/helpers/'

import { RootState, itemWebChatFull, CurrentComponent } from '@/types/webChatFull'

const defaultWidget = {
    logo: '',
    title: 'Opps!',
    description: '...',
    timeAttendance: '...',
    business: '',
    bgColor: 'bg-blue-700',
    color: '#00BCD4',
    token: ''
}

export const useWebChatFullStore = defineStore('webChatFull', {
    state : (): RootState => ({
        item: {
            currentComponent : 'loading',
            attendance : {
                id : null,
                unreadMessages : 0,
            },
            email: '',
            name: '',
            user: '', // token criptografado
            custom_token: '', // token criptografado
            apiKey: '',
            apiId : 0,
            currentPage: '',
            urlBase: '',
            wsToken: '', // token do websocket
            data: defaultWidget,
            businessId: 0,
            channel : 0,
        }
    }),
    getters: {
        me: (state) => state.item,
    },
    actions: {
        update(payload : itemWebChatFull) {
            if (!payload) return
            const result = assignEntries(this.item, payload) as itemWebChatFull
            this.item = result
        },
        setCurrentComponent(payload : CurrentComponent) {
            if(!payload) return
            this.item.currentComponent = payload
        },
    }
})
